import React, { useEffect, useRef } from "react";
import logoAssets from "../data/logoAssets";

const colorPalette = {
  0: "#50E3C2", 1: "#7FF1D5", 2: "#A8F7E2", 3: "#D0FCF0", 4: "#2BAF95",
  5: "#0A1F1F", 6: "#F4C542", 7: "#FF5E5E", 8: "#7ED957", 9: "#FFA552",
  10: "#F8F9FA", 11: "#C6CED3", 12: "#899CA3", 13: "#4A555A", 14: "#1B1F1F"
};

export default function CompanyLogo({
  accent,
  accentColor,
  base,
  baseColor,
  symbol,
  symbolColor,
}) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const w = canvas.width;
    const h = canvas.height;

    ctx.clearRect(0, 0, w, h);

    const drawLayer = (src, color) => {
      return new Promise(resolve => {
        if (!src || src === "") return resolve();

        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = src;

        img.onload = () => {
          const offCanvas = document.createElement("canvas");
          offCanvas.width = w;
          offCanvas.height = h;
          const offCtx = offCanvas.getContext("2d");

          offCtx.drawImage(img, 0, 0, w, h);

          offCtx.globalCompositeOperation = "source-in";
          offCtx.fillStyle = color || "#000";
          offCtx.fillRect(0, 0, w, h);
          offCtx.globalCompositeOperation = "source-over";

          ctx.shadowBlur = 6;
          ctx.shadowColor = color || "#000";
          ctx.drawImage(offCanvas, 0, 0, w, h);

          ctx.shadowBlur = 0;
          ctx.shadowColor = "transparent";

          resolve();
        };

        img.onerror = () => {
          console.error("Failed to load logo layer:", src);
          resolve();
        };
      });
    };

    const loadAndDraw = async () => {

      const baseSrc = logoAssets.baseShapes?.[base];
      const accentSrc = logoAssets.accents?.[accent];
      const symbolSrc = logoAssets.symbols?.[symbol];

      await drawLayer(baseSrc, colorPalette[baseColor]);
      await drawLayer(accentSrc, colorPalette[accentColor]);
      await drawLayer(symbolSrc, colorPalette[symbolColor]);
    };

    loadAndDraw();
  }, [accent, accentColor, base, baseColor, symbol, symbolColor]);

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <canvas
        ref={canvasRef}
        width={64}
        height={64}
        style={{
          width: "64px",
          height: "64px",
          display: "block",
          margin: "0 auto",
          maxWidth: "64px",
          maxHeight: "64px",
          objectFit: "contain"
        }}
      />
    </div>
  );
}